module.exports = __webpack_public_path__ + "img/img32.4a2a3eba.svg";